import { CDataTable } from "@coreui/react";
import { useTranslation } from "react-i18next";
import { LoadingSpinner, StepCard } from "src/components";
import UserManagementActions from "src/components/UserManagementActions/UserManagementActions";
import { useCollection } from "src/hooks/databaseHooks";
import { StyledSuperTable } from "../SuperAdminPage.style";

const UsersCard = ({ allOrgs }) => {
  const { t } = useTranslation();

  const { data: users, status } = useCollection(["admin-users"]);

  const tableItems =
    users?.flatMap((user) => {
      const id = user.id || user.NO_ID_FIELD;
      const orgs = [...new Set([user.organisation, ...(user.secondaryOrganisations || [])].filter(Boolean))];
      return orgs.map((orgId) => ({
        ...user,
        id,
        email: user.email || "",
        organisation: orgId,
        orgName: allOrgs.find((org) => org.id === orgId)?.name || orgId,
        created: user.created ? new Date(user.created).toISOString().split("T")[0] : "",
      }));
    }) || [];

  return (
    <>
      <StepCard>
        <StyledSuperTable className="w-100">
          {status !== "success" ? (
            <LoadingSpinner />
          ) : (
            <CDataTable
              itemsPerPageSelect={{ label: t("shared.itemsPerPage") }}
              pagination
              sorter
              hover
              columnFilter
              fields={[
                "email",
                { key: "created", label: "Created", sorter: true },

                "id",
                "organisation",
                { key: "orgName", label: "OrgName", sorter: true },
                { key: "actions", label: "Actions", sorter: false, filter: false },
              ]}
              items={tableItems}
              scopedSlots={{
                actions: (item) => <td><UserManagementActions user={item} orgId={item.organisation} orgName={item.orgName} /></td>,
              }}
            />
          )}
        </StyledSuperTable>
      </StepCard>

    </>
  );
};

export default UsersCard;
